module.exports = __webpack_public_path__ + "fonts/Gibson-Bold.f135cdd6.woff";